import styled from '@emotion/styled';
import { DateTime, formatToWeekDay } from 'infras/datetime';
import { gray02, gray04, gray06 } from 'presentations/views/styles/color';
import { memo, useContext, useMemo } from 'react';
import { CalendarContext } from 'presentations/views/components/atoms/Calendar/reducer/CalendarContext';
import Skeleton from 'presentations/views/components/atoms/Skeleton';
import {
  fontSize,
  fontWeight,
  mediaMax,
  spacing,
} from 'presentations/views/styles';

const Component = memo(() => {
  const { state } = useContext(CalendarContext);

  const isLoading = !state.isReady || state.currentPage === 0;
  const dates = useMemo(() => {
    const startedAt = state.now.set({ weekday: state.startWeekday });
    const items: DateTime[] = [];
    for (let i = 0; i < 7; i++) {
      const date = startedAt.plus({ day: i });
      items.push(date);
    }
    return items;
  }, [state.startWeekday, state.showRange, state.startedAt]);

  return (
    <Header maxCols={dates.length}>
      {dates.map((date: DateTime, i: number) =>
        isLoading ? (
          <Skeleton key={i} width={32} variant="text" />
        ) : (
          <WeekDay key={i} isHoliday={[0, 6].includes(date.weekday % 7)}>
            {formatToWeekDay(date)}
          </WeekDay>
        ),
      )}
    </Header>
  );
});

const Header = styled.div<{ maxCols: number }>`
  width: inherit;
  flex: 1 1 0%;
  display: grid;
  grid-template-columns: ${(props) =>
    `repeat(${props.maxCols}, minmax(1px, 1fr))`};
  grid-template-rows: repeat(1, minmax(18px, 1fr));
  border-bottom: 1px solid ${gray04};
`;
const WeekDay = styled.div<{ isHoliday: boolean }>`
  font-size: ${fontSize(13)};
  display: flex;
  justify-content: flex-end;
  padding: ${spacing(4)} ${spacing(8)};
  font-weight: ${fontWeight('bold')};
  line-height: 1;
  /* background-color: ${(props) => props.isHoliday && gray06}; */
  color: ${(props) => props.isHoliday && gray02};
  ${mediaMax.smartphone} {
    font-size: ${fontSize(10)};
  }
`;

export default Component;
